// Static configuration for RegisterForm: step count, age slider bounds,
// step 4 intent options, and the empty-form factory. Extracted so the
// component file focuses on behaviour, not data shapes.
import IconIntentRelationship from '../icons/IconIntentRelationship.vue';
import IconIntentRelaxed from '../icons/IconIntentRelaxed.vue';
import IconIntentFriendship from '../icons/IconIntentFriendship.vue';
import IconIntentOpen from '../icons/IconIntentOpen.vue';
import IconIntentNoAnswer from '../icons/IconIntentNoAnswer.vue';

// DB ids for smart_message_categories (see SmartMessageCategory::ID_*).
export const PREFERENCE_ID_TO_SLUG = {
  1: 'relationship',
  2: 'relaxed',
  3: 'friendship',
  4: 'open',
  5: 'no_answer',
};

export const TOTAL_STEPS = 5;
export const AGE_MIN = 18;
export const AGE_MAX = 100;
export const AGE_DEFAULT_FROM = 18;
export const AGE_DEFAULT_TO = 66;

export const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

// Pure age-range normalizer: clamp both ends to [AGE_MIN, AGE_MAX] and keep
// `from <= to`. `which` ('from' | 'to' | null) decides which end gives way when
// they cross — the one the user just dragged stays put. Returns a new
// { from, to } pair so callers never mutate in place.
export function clampAgeRange(from, to, which = null) {
  let f = clamp(from, AGE_MIN, AGE_MAX);
  let t = clamp(to, AGE_MIN, AGE_MAX);
  if (f > t) {
    if (which === 'from') {
      t = f;
    } else {
      f = t;
    }
  }
  return { from: f, to: t };
}

// Step 4 intent options — `value` lines up with what /register/update expects
// in the `preferences[]` array. Translation keys resolve at render time.
export const INTENTS = [
  {
    id: 1,
    value: 'relationship',
    labelKey: 'intent_relationship_label',
    descKey: 'intent_relationship_desc',
    icon: IconIntentRelationship,
  },
  {
    id: 2,
    value: 'relaxed',
    labelKey: 'intent_relaxed_label',
    descKey: 'intent_relaxed_desc',
    icon: IconIntentRelaxed,
  },
  {
    id: 3,
    value: 'friendship',
    labelKey: 'intent_friendship_label',
    descKey: 'intent_friendship_desc',
    icon: IconIntentFriendship,
  },
  {
    id: 4,
    value: 'open',
    labelKey: 'intent_open_label',
    descKey: 'intent_open_desc',
    icon: IconIntentOpen,
  },
  {
    id: 5,
    value: 'no_answer',
    labelKey: 'intent_no_answer_label',
    descKey: 'intent_no_answer_desc',
    icon: IconIntentNoAnswer,
    fullWidth: true,
  },
];

export const EMPTY_FORM = () => ({
  // step 1
  day: '',
  month: '',
  year: '',
  // step 2
  locationId: null,
  locationLabel: '',
  // step 3
  gender: null,
  preferredGender: null,
  ageFrom: AGE_DEFAULT_FROM,
  ageTo: AGE_DEFAULT_TO,
  // step 4
  preferences: [],
  // step 5
  name: '',
  email: '',
  password: '',
  terms: false,
});
